var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { resourcesByResourceName } from '../../../graphql/queries';
import { listResourcesQuery } from './graphql';
/**
 * Gets the resource metadata from the backend
 * @param resourceName
 */
export function getBackendResource(resourceName) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(resourcesByResourceName, { resourceName }).then((res) => {
            var _a, _b;
            const items = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.resourcesByResourceName) === null || _b === void 0 ? void 0 : _b.items;
            if (items.length && items[0] && items[0].resourceName === resourceName) {
                return items[0];
            }
        });
    });
}
/**
 * List all resources
 * @param filter Limit the returned resources using the filter
 */
function listAllResources(filter) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(listResourcesQuery, { filter }).then((res) => {
            var _a, _b;
            return (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.listResources) === null || _b === void 0 ? void 0 : _b.items;
        });
    });
}
/**
 * List all resources with their metadata
 */
export function listAllResourceNames() {
    return __awaiter(this, void 0, void 0, function* () {
        return listAllResources(null);
    });
}
/**
 * Checks if a resource name is a valid upload
 * @param resourceName
 */
export function isValidUpload(resourceName) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield getBackendResource(resourceName)) === undefined;
    });
}
